import type { CommonService } from '../../components/common/common.service'

import { app } from '../../app.module'

/**
 * アカウントの基本データの表示
 * @class AccountInfo
 */
class AccountInfo {
  private snsType: string
  private screen: string
  private caption: string
  private accountData
  private publishDate: string
  private followerText: string

  constructor(
    private $scope,
    private $state,
    private $filter,
    private CommonService: CommonService
  ) {}

  /**
   * 初期化
   * @returns {void}
   */
  public $onInit(): void {
    this.followerText = 'フォロワー数'

    // 表示するフォロワー数
    let screen = this.$state.current.name

    // 画面が指定されている場合、セット
    if (this.screen !== undefined) {
      screen = this.screen
    }

    // アカウント名と画像をセット
    switch (screen) {
      // 投稿画or分析画面の場合
      case 'post':
      case 'analytics':
      case 'archive':
        // 投稿日時、メインカテゴリ、サブカテゴリを成形してセット
        this.caption =
          this.publishDate +
          ' | ' +
          this.accountData.categoryName +
          ' : ' +
          this.accountData.subCategoryName +
          ' | '
        break

      // アカウント画面の場合
      case 'account':
        // メインカテゴリとサブカテゴリを成形してセット
        this.caption = this.accountData.categoryName + ' : ' + this.accountData.subCategoryName
        break

      // アカウント詳細モーダルの場合
      case 'account-detail-modal':
      case 'home':
        // メインカテゴリとサブカテゴリを成形してセット
        this.caption = this.accountData.categoryName + ' : ' + this.accountData.subCategoryName

        // フォロワー数が非公開の場合は文字列をセット
        if (this.accountData.hiddenSubscribersFlg === 1) {
          this.caption = this.caption + ' | ' + this.followerText + ': 非公開'
        }

        // フォロワー数が公開されている場合はフォロワー数をセット
        if (this.accountData.hiddenSubscribersFlg !== 1) {
          this.caption =
            this.caption +
            ' | ' +
            this.followerText +
            ': ' +
            this.accountData.followers.toLocaleString()
        }

        if (screen === 'home') {
          this.caption = `${this.$filter('capitalize')(this.snsType)} | ${this.caption}`
        }
        break
    }
  }

  /**
   * アカウント詳細モーダルを表示
   * @returns {void}
   */
  public showAccountDetail(): void {
    this.CommonService.showAccountDetailModal(this.snsType, 'analytics', this.accountData.accountId)
  }
}

app.component('accountInfo', {
  bindings: {
    snsType: '@',
    screen: '@',
    publishDate: '@',
    accountData: '<',
    showAccountInfoFlg: '@',
    showAccountDetailModalFlg: '=',
    musicData: '=',
  },
  template: require('./account-info.pug')(),
  controller: AccountInfo,
})
